import { render, staticRenderFns } from "./WinnerCoefHighlight.vue?vue&type=template&id=5ac26bfc&scoped=true&"
import script from "./WinnerCoefHighlight.vue?vue&type=script&lang=js&"
export * from "./WinnerCoefHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac26bfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
